import {RSAA} from "redux-api-middleware";

export const NEWS_FEED_SET = "NEWS_FEED_SET";
export const NEWS_FEED_LOAD = "NEWS_FEED_LOAD";

/**
 * Api returns html-encoded strings. We want to decode them and let React do the escaping
 * @param input
 * @returns {string}
 */
const decodeHtmlEncodedString = (input) => {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
};

const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date.toTimeString().substr(0, 5);
};

const setFeedAction = (sport, items) => ({
    type: NEWS_FEED_SET,
    payload: {
        sport,
        items
    }
});

export const fetchFeedAction = (sport) => (dispatch, getStore) => {
    if (getStore().newsFeed.sport === sport) {
        return;
    }

    const newsFeedName = (sport === 'football') ? 'footballFeed' : 'dartsNewsFeed';

    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/proxy/${newsFeedName}/${sport}/newPosts`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                {
                    type: NEWS_FEED_LOAD,
                    payload: {
                        sport
                    }
                },
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => {
                                dispatch(setFeedAction(sport, json.map(item => ({
                                    link: item.link + '?utm_source=zweeler&utm_medium=newsFeed',
                                    id: item.id,
                                    title: decodeHtmlEncodedString(item.title.rendered),
                                    publishedOnTime: formatTime(item.date)
                                }))));
                            }
                        )
                    )
                },
                'FAILURE'
            ]
        }
    });
};